import { useCallback, useRef, useState } from "react";
import { mount } from "../3d/BlenderScene.jsx";
import CircularProgress from "@mui/material/CircularProgress";

type threeDProps = {
    height: string,
    width: string,
    model: string,
    texture: string,
    isMobile: boolean
}

export function Canvas3D({ height, width, model, texture, isMobile }: threeDProps) {
    const [isLoading, setIsLoading] = useState(true);
    const cleanupRef = useRef<null | (() => void)>(null);

    const containerRef = useCallback((container: HTMLElement | null) => {
        if (cleanupRef.current) cleanupRef.current();

        if (container) {
            const cleanup = mount(container, model, texture, (p: number) => {
                if (p === 100) setTimeout(() => setIsLoading(false), 500);
            });
            cleanupRef.current = cleanup;
        }
    }, [model, texture]);

    return (
        <div style={{ position: "relative", height, width, marginBottom: "20px" }}>
            {
                isLoading &&
                <div
                    style={{
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                    
                >
                    <CircularProgress color="secondary" />
                </div>
            }

            <div
                ref={containerRef}
                style={{
                    height: "100%",
                    width: "100%",
                    pointerEvents: isMobile ? "none" : undefined,
                    cursor: "grab",
                }}
            />
        </div>
    );
}